export default "/assets/66169f76f970f2df.png"